// extracted by mini-css-extract-plugin
export default {"footer-nav":"vDHhQ","footer-nav__wrapper":"YVxtv","footer-nav__button":"QRXsj"};